import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedGymListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface IUseGyms {
  search?: string;
}

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey?: (string | undefined)[];
}

function useGyms({ search }: IUseGyms): UseInfiniteQueryResult<AxiosResponse<PaginatedGymListList>> {
  const fetchGyms = useCallback(
    ({
      pageParam = { limit: '20', offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedGymListList>> => {
      const params = pageParam;

      if (search) {
        params.search = search;
      }

      return client.get(`gyms/?${encodeUrlParams(params)}`);
    },
    [search],
  );

  return useInfiniteQuery(['gyms', search], fetchGyms, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useGyms;
